module.exports = __webpack_public_path__ + "static/media/CommerceSandbox_Square.f2877216.png";